import { createAction, createReducer } from '@reduxjs/toolkit';
import { IAction } from './interface/apiSingle';
import { IInitialState } from './interface/reduxApi';

const INITIAL_STATE: IInitialState = {
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  isActive: false,
  clientIsLoaded: false,
  credit: 0,
  debit: 0,
  balance: 0,
};

export const getSingleClient = createAction<any>(
  '@clientsApp/single/GET_SINGLE_CLIENT'
);
export const resetApiBalanceAction = createAction(
  '@clientsApp/single/GET_RESET_API_BALANCE'
);

export const gotSingleClient = createAction<any>(
  '@clientsApp/single/GOT_SINGLE_CLIENT'
);

export const gotError = createAction('@clientsApp/single/GOT_ERROR');

const getSingleReducer = createReducer(INITIAL_STATE, {
  [getSingleClient.type]: (state, action: IAction) => ({
    ...state,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
    credit: action.payload.Credito,
    debit: action.payload.Debito,
    balance: action.payload.Saldo,
  }),
  [gotSingleClient.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    credit: action.payload.Credito,
    debit: action.payload.Debito,
    balance: action.payload.Saldo,
  }),
  [resetApiBalanceAction.type]: (state) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    credit: 0,
    debit: 0,
    balance: 0,
  }),
  [gotError.type]: (state) => ({
    ...state,
    isLoading: false,
    gotSuccess: false,
    clientsIsLoaded: false,
    partnersIsLoaded: false,
    gotError: true,
  }),
});

export default getSingleReducer;
